var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-dark font-size-18 font-weight-bold mb-1"},[_vm._v("Year Profit")]),_c('div',{staticClass:"text-gray-6 mb-2"},[_vm._v("Revenue by location and date")]),_c('vue-chartist',{staticClass:"height-200",class:_vm.$style.chart,attrs:{"type":"Bar","data":_vm.data,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }